// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
"use client";

import PropTypes from "prop-types";
import styled from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVG = styled.svg.withConfig({
  componentId: "sc-1r0aqln-0"
})(["min-width:", ";max-width:", ";height:", ";"], _ref => {
  let {
    $size
  } = _ref;
  return $size;
}, _ref2 => {
  let {
    $size
  } = _ref2;
  return $size;
}, _ref3 => {
  let {
    $size
  } = _ref3;
  return $size;
});
const AlertWarningFilled = _ref4 => {
  let {
    size = "1em",
    color = "currentColor",
    title,
    ...props
  } = _ref4;
  return /*#__PURE__*/_jsxs(SVG, {
    ...props,
    $size: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: title ? 'img' : 'presentation',
    children: [title ? /*#__PURE__*/_jsx("title", {
      children: title
    }) : null, " ", /*#__PURE__*/_jsx("path", {
      fill: color,
      d: "M11.104 3.717a1.035 1.035 0 011.792 0l8.964 15.526c.398.69-.1 1.552-.897 1.552H3.037a1.035 1.035 0 01-.897-1.552l8.964-15.525zm2.075 5.148h-2.357l.222 5.685h1.914l.22-5.685zm.081 8.185a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      children: " "
    })]
  });
};
AlertWarningFilled.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,
  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,
  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default AlertWarningFilled;